.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.card {
  padding: 28px 24px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-bg-card);
  text-align: center;
}

.cardTitle {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 700;
}

.cardText {
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-text-muted);
}

.downloadBtn {
  width: 100%;
}

.note {
  margin-bottom: 12px;
  font-size: 14px;
  text-align: center;
  color: var(--color-text-dim);
}

.disclaimer {
  max-width: 820px;
  margin: 0 auto 24px;
  font-size: 12px;
  line-height: 1.55;
  text-align: center;
  color: var(--color-text-dim);
  opacity: 0.9;
}

.mainCta {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
